// src/features/files/upload/acceptsFile.js

/**
 * Whether `file` matches an `accept` string like the file input's
 * ("application/pdf,.pdf", "image/*"). No accept string accepts everything.
 */
export function acceptsFile(file, accept) {
  if (!accept) return true;
  const name = (file.name || '').toLowerCase();
  const type = (file.type || '').toLowerCase();
  return accept.split(',').map(rule => rule.trim().toLowerCase()).filter(Boolean).some((rule) => {
    if (rule.startsWith('.')) return name.endsWith(rule);
    if (rule.endsWith('/*')) return type.startsWith(rule.slice(0, -1));
    return type === rule;
  });
}
